import { useState, useEffect } from 'react'
import { Wifi, WifiOff } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

export default function ConnectionIndicator() {
  const [online, setOnline] = useState(navigator.onLine)
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true)
      setShowBanner(true)
      setTimeout(() => setShowBanner(false), 3000)
    }
    const handleOffline = () => {
      setOnline(false)
      setShowBanner(true)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ type: 'spring', damping: 20, stiffness: 300 }}
          className="fixed top-0 left-0 right-0 z-[90] flex items-center justify-center py-2 px-4"
          style={{
            background: online
              ? 'linear-gradient(90deg, rgba(16,185,129,0.15), rgba(16,185,129,0.05))'
              : 'linear-gradient(90deg, rgba(239,68,68,0.15), rgba(239,68,68,0.05))',
            borderBottom: `1px solid ${online ? 'rgba(16,185,129,0.2)' : 'rgba(239,68,68,0.2)'}`,
            backdropFilter: 'blur(12px)',
          }}
        >
          <div className="flex items-center gap-2">
            {online ? (
              <>
                <div className="w-2 h-2 rounded-full connection-dot" style={{ background: '#10b981' }} />
                <Wifi className="w-3.5 h-3.5" style={{ color: '#10b981' }} />
                <span className="text-xs font-medium" style={{ color: '#10b981' }}>
                  Connection restored
                </span>
              </>
            ) : (
              <>
                <div className="w-2 h-2 rounded-full" style={{ background: '#ef4444' }} />
                <WifiOff className="w-3.5 h-3.5" style={{ color: '#ef4444' }} />
                <span className="text-xs font-medium" style={{ color: '#ef4444' }}>
                  No internet connection
                </span>
              </>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
